<template>
  <div class="initial-content card-body p-2">
    <McAlert
      withIcon
      variant="info"
      :text="$t('fleetTask.transferDeliveryModal.initial.alert')"
    />
    <b-row>
      <b-col v-for="item in typeMapping" :key="item.key" md="6">
        <button
          :class="[
            'type-card',
            'type-card--with-hover-effect',
            {
              'type-card--is-selected': selectedType == item.key,
            },
          ]"
          @click="() => $emit('click-card', item.key)"
        >
          <i :class="item.icon"></i>
          <div>
            <p class="type-card__title">{{ item.title }}</p>
            <p class="type-card__description mb-0">{{ item.description }}</p>
          </div>
        </button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import McAlert from '@/components/McAlert.vue'

export default {
  components: {
    McAlert,
  },
  props: {
    selectedType: {
      type: String,
    },
  },
  emits: ['click-card'],
  computed: {
    typeMapping() {
      return [
        {
          key: 'create',
          icon: 'icon-outline_file',
          title: this.$t('fleetTask.transferDeliveryModal.initial.options.create.title'),
          description: this.$t('fleetTask.transferDeliveryModal.initial.options.create.description'),
        },
        {
          key: 'exist',
          icon: 'icon-outline_fleet-order',
          title: this.$t('fleetTask.transferDeliveryModal.initial.options.exist.title'),
          description: this.$t('fleetTask.transferDeliveryModal.initial.options.exist.description'),
        },
      ]
    },
  },
  methods: {
    handleSelectType(type) {
      this.selectedType = type
    }
  },
}
</script>

<style lang="scss" scoped>
.initial-content {
  display: flex;
  flex-direction: column;
  gap: 24px;

  .type-card {
    width: 100%;
    background: white;
    text-align: center;
    padding: 12px;
    border: 1px solid rgba(235, 236, 239, 1);
    border-radius: 8px;
  
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  
    i {
      font-size: 32px;
    }
  
    &--with-hover-effect {
      &:hover {
        background-color: $mep-color-text-100;
      }
    }
  
    &--is-selected {
      background-color: $mep-color-text-100;
    }
  
    &__title {
      font-weight: 600;
      margin-bottom: 4px;
      color: $mep-color-text;
    }
    &__description {
      color: $mep-color-text-300;
    }
  }
}
</style>
